import fetch from 'auth/FetchInterceptor'
import {X_API_KEY} from "../configs/AppConfig";
import {AUTH_TIPE} from "../constants/AuthConstant";

const exitClearenceService = {}

exitClearenceService.data = function (token, data = '') {
    return fetch({
        url: '/transaksi/pegawai-exit-clearence/data',
        method: 'post',
        data: data,
        params: {},
        headers: {
            "x-api-key": X_API_KEY,
            "x-admin": localStorage.getItem(AUTH_TIPE)
        }
    })
}

exitClearenceService.update = function (data) {
    return fetch({
        url: '/transaksi/pegawai-exit-clearence/update',
        method: 'post',
        data: data,
        headers: {
            "x-api-key": X_API_KEY,
            "x-admin": localStorage.getItem(AUTH_TIPE)
        }
    })
}

exitClearenceService.cetakPaklaring = function (data) {
    return fetch({
        url: '/transaksi/pegawai-exit-clearence/cetak_paklaring',
        method: 'post',
        data: data,
        headers: {
            "x-api-key": X_API_KEY,
            "x-admin": localStorage.getItem(AUTH_TIPE)
        }
    })
}

export default exitClearenceService;
